import React, { useState } from 'react';
import PropTypes from 'prop-types';

import pluralize from 'pluralize';

import { connect } from 'react-redux';
import { updateUserPlans } from '../store/users/actions';

import MultiselectModal from 'components/multiselect_modal';

export function UserPlans({ plans, updateUserPlans, user }) {
  const [showPlansModal, setShowPlansModal] = useState(false);

  const assignedPlans = plans.filter(plan => plan.users.some(planUser => planUser.id === user.id));

  return <React.Fragment>
    <a className="clickable" onClick={() => setShowPlansModal(true)}>
      {pluralize('plans', assignedPlans.length, true)}
    </a>

    <MultiselectModal
      allowEmptySelection
      optionLabelName="name"
      options={plans.filter(plan => !plan.archived)}
      optionsLabel="Plans"
      optionValueName="id"
      show={showPlansModal}
      title="Assign Plans"
      value={assignedPlans}
      onClose={() => setShowPlansModal(false)}
      onSave={plans => updateUserPlans(user, plans)}
    />
  </React.Fragment>;
}

UserPlans.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.shape({
    archived: PropTypes.bool,
    users: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
  })).isRequired,
  updateUserPlans: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  plans: state.plans,
});


const mapDispatchToProps = {
  updateUserPlans,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPlans);
